export const CanvasSearch = {
  extends: ['SearchBar'],
  tag: 'search',
  state: {
    recents: []
  },
  onInit: (el, s) => {
    const projectKey = el.getAppKey()
    const recentKey = projectKey + '_recentSearches'
    const recentsValue = window.localStorage.getItem(recentKey)
    let recents = JSON.parse(recentsValue || '[]')

    if (!recents.length) {
      const components =
        el.getSchema('components') || el.call('getData', 'components') || {}
      recents = Object.values(components).map((v) => ({
        key: v.key,
        type: v.type,
        title: v.title
      }))
    }

    s.recents = recents.slice(0, 15)
  }
}
